<template>
  <OAccordion
    v-for="item in agrupamento"
    :key="item.id"
    class="bg-card-100 border border-neutral-100/10 overflow-hidden !rounded-md mt-8 space-y-12"
  >
    <template #header>
      <div
        class="flex items-center gap-8 text-paragraph-4 text-neutral-40"
      >
        <span class="text-headline-4 text-neutral-100">
          {{ t('send') }} {{ item.contagem_envio }}
        </span>
        •
        <span class="text-paragraph-4 text-neutral-70">
          {{ FData(item.data_envio) }}
        </span>
        •
        <OBadgeStatus
          :color="setColorStatus(item.status)"
          size="md"
          class="h-24"
        >
          <template #content>
            <p class="text-center mx-auto" square>
              {{ setNomeStatus(item.status, t) }}
            </p>
          </template>
        </OBadgeStatus>
      </div>
      <div class="flex-1" />
    </template>

    <QCardSection class="flex flex-col gap-16 p-12">
      <template v-if="item.arquivos?.length">
        <p class="text-caps-3 text-neutral-70">
          {{ t('attachments') }}
        </p>

        <q-list class="w-full space-y-8">
          <template v-for="file in item.arquivos" :key="file.id">
            <OFileDownload
              :file="file"
              :name="file.arquivo.split('/').pop()"
            />
          </template>
        </q-list>
      </template>

      <OInput
        v-if="item.comentario"
        :model-value="item.comentario"
        size="lg"
        type="textarea"
        :label="t('comment')"
        disabled
        readonly
        class="readonly label-transparent"
      />

      <OInput
        v-if="item.comentario_supervisor"
        :model-value="item.comentario_supervisor"
        size="lg"
        type="textarea"
        :label="t('logbitsComments')"
        disabled
        readonly
        class="readonly label-transparent"
      />
    </QCardSection>
  </OAccordion>
</template>

<script></script>

<script setup>
import { useI18n } from 'vue-i18n'
import { setColorStatus, setNomeStatus, FData } from 'js/utils/GLOBAL'
import OAccordion from './OAccordion.vue'
import OFileDownload from 'components/FileUploader/OFileDownload.vue'
import OBadgeStatus from 'components/Badge/OBadgeStatus.vue'
import OInput from 'components/Input/OInput.vue'

const { t } = useI18n()

const props = defineProps({
  agrupamento: Array,
})
</script>

<style lang="scss" scoped></style>
